import { PageTypePrefixes, defaultLanguage } from '@stereoagency/constants';
import flush from 'just-flush';

type ObjectType =
  | 'page'
  | 'article'
  | 'event'
  | 'researchGroup'
  | 'researchPlatform'
  | 'researchProject';

export default function createDocumentURL(
  lang: string,
  type: ObjectType,
  slug: string | null
) {
  const prefixes = PageTypePrefixes[lang];
  const languagePrefix = lang === defaultLanguage.id ? null : lang;

  const prefix = type === 'page' ? null : prefixes[type];
  return `/${flush([languagePrefix, prefix, slug]).join('/')}`;
}
